import Anchor from '@/common/Anchor';
import { TitleWrap, Title, Text } from '@/vdp/AlertModal';
import { useDDAddAction } from '~/hooks/common/telemetry';
import AlertIcon from './AlertIcon';

const OutOfMarket = () => {
  useDDAddAction('Out Of Market - Banner Shown');

  return (
    <>
      <TitleWrap>
        <AlertIcon />
        <Title>Out Of Market</Title>
      </TitleWrap>
      <Text>
        Unfortunately, this is one of the few locations where Carvana’s haulers
        don’t deliver. For more information on where we do deliver, visit our{' '}
        <Anchor
          href="/faq"
          target="_blank"
          rel="noopener"
          data-analytics-id="Alerts - Out of Market FAQ"
        >
          FAQ page
        </Anchor>
        .
      </Text>
    </>
  );
};

export default OutOfMarket;
